import { render, staticRenderFns } from "./add-solution.vue?vue&type=template&id=078a65d1&scoped=true"
import script from "./add-solution.vue?vue&type=script&lang=js"
export * from "./add-solution.vue?vue&type=script&lang=js"
import style0 from "./add-solution.vue?vue&type=style&index=0&id=078a65d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078a65d1",
  null
  
)

export default component.exports